<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Produits de partenariat" />
            <ProduitPartenariat />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import ProduitPartenariat from '../Services/ProduitPartenariat'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'ProduitPartenariatPage',
    components: {
        NavBar,
        PageTitle,
        ProduitPartenariat,
        FooterComp,
    }
}
</script>